/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, July 8th 2022, 7:37:46 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { TaskTemplate } from "lib/schemas";
import { useWorkflowStore, getUserTaskTypesData } from "service-builder/stores";
import { ListButtonAutoCompleteFormInput } from "ui-widgets/forms";
import { IconText } from "ui-widgets";
import { getUserTaskTypeWidgets, SUPPORTED_AUTOMATED_TASK_TYPES_WIDGETS } from "./TaskTypeWidgets";

export const UserTaskTypeFormInput = () => {
  const userTaskTypeWidgets = getUserTaskTypeWidgets(useWorkflowStore(getUserTaskTypesData));

  return (
    <ListButtonAutoCompleteFormInput<TaskTemplate>
      schema_field_key="user_action_type"
      label="User Task Type"
      options={Object.keys(userTaskTypeWidgets)}
      getOptionLabel={(option) => userTaskTypeWidgets[option]?.userTaskTypeTitle} // For the TextField
      getPrimaryOptionLabel={(option) => (
        <IconText
          icon={userTaskTypeWidgets[option]?.userTaskTypeIcon}
          textComponent={userTaskTypeWidgets[option]?.userTaskTypeTitle}
        />
      )}
      getSecondaryOptionLabel={(option) => userTaskTypeWidgets[option]?.userTaskTypeDescription}
    />
  );
};

export const AutomatedTaskTypeFormInput = () => (
  <ListButtonAutoCompleteFormInput<TaskTemplate>
    schema_field_key="automated_task_type"
    label="Automated Task Type"
    options={Object.keys(SUPPORTED_AUTOMATED_TASK_TYPES_WIDGETS)}
    getOptionLabel={(option) => SUPPORTED_AUTOMATED_TASK_TYPES_WIDGETS[option].automatedTaskTypeTitle} // For the TextField
    getPrimaryOptionLabel={(option) => (
      <IconText
        icon={SUPPORTED_AUTOMATED_TASK_TYPES_WIDGETS[option].automatedTaskTypeIcon}
        textComponent={SUPPORTED_AUTOMATED_TASK_TYPES_WIDGETS[option]}
      />
    )}
    getSecondaryOptionLabel={(option) => SUPPORTED_AUTOMATED_TASK_TYPES_WIDGETS[option].automatedTaskTypeDescription}
  />
);
